import { Component } from '@angular/core';
import { PDQService } from 'src/app/services/pdq.service';
import { SwalToastService } from 'src/app/services/swal.service';
import xmlFormat from 'xml-formatter';

@Component({
  selector: 'app-pdqv3',
  templateUrl: './pdqv3.component.html',
  styleUrls: ['./pdqv3.component.css'],
  standalone: false,
})
export class Pdqv3Component {
  ip: string = '192.67.249.3';
  port: number = 8800;

  soapFile: File | null = null;

  result = '-';
  resultRows = 1;

  constructor(
    private readonly pdqservice: PDQService,
    private readonly swalToastService: SwalToastService
  ) {}

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.soapFile = input.files[0];
    }
  }

  pdqv3() {
    if (!this.soapFile) {
      this.swalToastService.toastError('Please upload a SOAP XML file');
      return;
    }

    const formData = new FormData();
    formData.append('ip', this.ip);
    formData.append('port', this.port.toString());
    formData.append('soapFile', this.soapFile);

    this.pdqservice.pdqv3(formData).subscribe({
      next: (response) => {
        this.result = xmlFormat(response);
        const lineCount = (this.result.match(/\n/g) || []).length + 1;
        this.resultRows = Math.min(Math.max(lineCount, 1), 20);
      },
      error: (err) => {
        this.swalToastService.toastError('Unable to get PDQv3');
        console.error('Error sending PDQv3:', err);
      },
    });
  }

  runthisquery(type: string) {
    this.pdqservice.runTestQuery(type).subscribe({
      next: (res: any) => {
        this.result = res.responseBody || JSON.stringify(res, null, 2);
      },
      error: (err: any) => {
        this.result = 'Error: ' + (err.error?.message || err.message);
      },
    });
  }
}
